import { SnackbarProvider as NotistackProvider, MaterialDesignContent } from 'notistack';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Grow } from '@mui/material';
import {
  forwardRef, useState,
} from 'react';
import { createPortal } from 'react-dom';

const StyledContent = styled(MaterialDesignContent)`
  ${({ theme }) => `
    &.notistack-MuiContent {
      background-color: ${theme.palette.grey[5]};
      color: ${theme.palette.grey[100]};
      font-size: 14px;
      svg {
        color: ${theme.palette.success.main};
      }
    }
    &.notistack-MuiContent-error svg {
      color: ${theme.palette.error[100]};
    }
  `}
`;

const snackbarComponents = {
  default: StyledContent,
  success: StyledContent,
  error: StyledContent,
  warning: StyledContent,
  info: StyledContent,
};

const notistackRoot = document.getElementById('notistackHelper');

const AlertContainer = forwardRef((props, ref) => (
  <>
    {createPortal(
      <div css={css`position: absolute;`} ref={ref} />,
      notistackRoot,
    )}
  </>
));

export const SnackbarProvider = ({ children }) => {
  const [alertContainer, setAlertContainer] = useState(null);
  return (
    <>
      <AlertContainer ref={setAlertContainer} />
      <NotistackProvider
        domRoot={alertContainer}
        maxSnack={5}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        TransitionComponent={Grow}
        Components={snackbarComponents}
      >
        {children}
      </NotistackProvider>
    </>
  );
};

SnackbarProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
